const PrescriptionSelectConfig = [{ span: 12, height: "74px", classes: "marginTop-24" }]
export default PrescriptionSelectConfig
